
import { Link } from 'react-router-dom';
import NavBar from '../../components/feature/NavBar';
import Services from '../home/components/Services';
import WhyChoose from '../home/components/WhyChoose';
import SEOHead from '../../components/feature/SEOHead';

const siteUrl = import.meta.env.VITE_SITE_URL || 'https://zjfitservices.com';

const servicesJsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: 'IT Deployment Services NYC | ZJF IT Services LLC',
    description: 'Explore ZJF IT Services\' full range of IT deployment services including workstation rollouts, structured cabling, network installations, IMAC services, and office IT relocations across New York and nationwide.',
    url: `${siteUrl}/services`,
    breadcrumb: {
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: 'Home', item: siteUrl },
        { '@type': 'ListItem', position: 2, name: 'Services', item: `${siteUrl}/services` },
      ],
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Service',
    serviceType: 'IT Deployment Services',
    provider: {
      '@type': 'LocalBusiness',
      name: 'ZJF IT Services LLC',
      url: siteUrl,
    },
    areaServed: { '@type': 'Country', name: 'United States' },
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'IT Deployment Services',
      itemListElement: [
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Enterprise Workstation Rollouts' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Structured Cabling' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Network Hardware Installation' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'IMAC Services' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'Office IT Relocation' } },
        { '@type': 'Offer', itemOffered: { '@type': 'Service', name: 'End-User Support' } },
      ],
    },
  },
];

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-zinc-950">
      <SEOHead
        title="IT Deployment Services NYC | ZJF IT Services LLC"
        description="Explore ZJF IT Services' full range of IT deployment services including workstation rollouts, structured cabling, network installations, IMAC services, and office IT relocations across New York and nationwide."
        keywords="IT deployment services NYC, workstation rollouts New York, structured cabling, network installation, IMAC services, office IT relocation"
        canonical={`${siteUrl}/services`}
        jsonLd={servicesJsonLd}
      />
      <NavBar />
      <div className="pt-20">
        <div className="py-16 bg-zinc-950 text-center border-b border-zinc-800">
          <span className="text-orange-500 text-sm font-semibold uppercase tracking-widest mb-3 block">What We Do</span>
          <h1 className="text-5xl font-bold text-white mb-4">Our Services</h1>
          <p className="text-zinc-400 text-lg max-w-2xl mx-auto">
            Professional IT deployment and field services across NYC and nationwide.
          </p>
        </div>
        <Services />
        <WhyChoose />
        <div className="py-16 bg-zinc-950 text-center">
          <Link
            to="/contact"
            className="bg-orange-500 hover:bg-orange-600 text-white px-10 py-4 rounded-md text-base font-semibold transition-all duration-300 whitespace-nowrap cursor-pointer inline-block"
          >
            Request a Consultation
          </Link>
        </div>
      </div>
    </div>
  );
}
